export const originalCourses = {
  KickStart: [
    {
      id: 'courses/introduction-to-programming',
      title: 'Introduction to Programming',
      img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
      desc: 'Kick-start your coding journey',
      freeCourse: true,
    },
    {
      id: 'courses/number-system',
      title: 'Number System',
      img: '/Assets/navIcons/coursesNavIcons/NumberSystemIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/NumberSystemIconWhite.svg',
      desc: 'Understand various number systems',
      newCourse: true,
      pricing: { IN: '₹499' },
    },
  ],
  ProgrammingLanguage: [
    {
      id: 'courses/python',
      title: 'Python',
      img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PythonIconWhite.svg',
      desc: 'Learn python from scratch',
      pricing: { IN: '₹499' },
    },
    {
      id: 'courses/c-programming',
      title: 'C Programming',
      img: '/Assets/navIcons/coursesNavIcons/CPrgIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CPrgIconWhite.svg',
      desc: 'Master C programming',
      pricing: { IN: '₹499' },
    },
    {
      id: 'courses/pointers-in-c',
      title: 'Advanced Pointers',
      img: '/Assets/navIcons/coursesNavIcons/PointersIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PointersIconWhite.svg',
      desc: 'In-depth pointers course',
      pricing: { IN: '₹499' },
    },
  ],
  FundamentalProblemSolving: [
    {
      id: 'courses/problem-solving-beginners',
      title: 'Problem Solving Beginners',
      img: '/Assets/navIcons/coursesNavIcons/ProblemsBeginnerIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemsBeginnerIconWhite.svg',
      desc: `Let's solve basic coding problems`,
      freeCourse: true,
    },
    {
      id: 'courses/problem-solving-beginners-python',
      title: 'Problem Solving Beginners in Python',
      img: '/Assets/navIcons/coursesNavIcons/ProblemsBeginnerIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemsBeginnerIconWhite.svg',
      desc: `Start solving beginner problems with Python`,
      pricing: { IN: '₹499' },
    },
  ],
  DataStructures: [
    {
      id: 'courses/data-structures-in-c',
      title: 'Data Structures in C',
      img: '/Assets/navIcons/coursesNavIcons/DSACIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACIconWhite.svg',
      desc: 'Master Data Structures in C',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/data-structures-java',
      title: 'Data Structures in Java',
      img: '/Assets/navIcons/coursesNavIcons/DSAJavaIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSAJavaIconWhite.svg',
      desc: 'Master Data Structures in Java',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/data-structures-python',
      title: 'Data Structures in Python',
      img: '/Assets/navIcons/coursesNavIcons/DSAPythonIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSAPythonIconWhite.svg',
      desc: 'Master Data Structures in Python',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/data-structures-cpp',
      title: 'Data Structures C++',
      img: '/Assets/navIcons/coursesNavIcons/DSACppIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACppIconWhite.svg',
      desc: 'Master Data Structures in C++',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/data-structures-js',
      title: 'Data Structures in Js',
      img: '/Assets/navIcons/coursesNavIcons/DSAJsIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSAJsIconWhite.svg',
      desc: 'Master Data Structures in JavaScript',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/data-structures-cs',
      title: 'Data Structures in C#',
      img: '/Assets/navIcons/coursesNavIcons/DSACSharpIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACSharpIconWhite.svg',
      desc: 'Master Data Structures in C#',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/advanced-data-structures',
      title: 'Advanced Data Structures',
      img: '/Assets/navIcons/coursesNavIcons/AdvancedDSAIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AdvancedDSAIconWhite.svg',
      desc: 'Learn advanced data structures',
      pricing: { IN: '₹1999' },
    },
  ],
  Algorithms: [
    {
      id: 'courses/algorithms',
      title: 'Algorithms in C',
      img: '/Assets/navIcons/coursesNavIcons/AlgoCIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AlgoCIconWhite.svg',
      desc: 'Master Algorithms in C',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/algorithms-java',
      title: 'Algorithms in Java',
      img: '/Assets/navIcons/coursesNavIcons/AlgoJavaIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AlgoJavaIconWhite.svg',
      desc: 'Master Algorithms in Java',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/algorithms-python',
      title: 'Algorithms in Python',
      img: '/Assets/navIcons/coursesNavIcons/AlgoPythonIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AlgoPythonIconWhite.svg',
      desc: 'Master Algorithms in Python',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/algorithms-cpp',
      title: 'Algorithms in C++',
      img: '/Assets/navIcons/coursesNavIcons/AlgoCppIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AlgoCppIconWhite.svg',
      desc: 'Master Algorithms in C++',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/algorithms-js',
      title: 'Algorithms in Js',
      img: '/Assets/navIcons/coursesNavIcons/AlgoJsIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AlgoJsIconWhite.svg',
      desc: 'Master Algorithms in JavaScript',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/algorithms-cs',
      title: 'Algorithms in C#',
      img: '/Assets/navIcons/coursesNavIcons/AlgoCSharpIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AlgoCSharpIconWhite.svg',
      desc: 'Master Algorithms in C#',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/time-complexity-analysis',
      title: 'Time Complexity Analysis',
      img: '/Assets/navIcons/coursesNavIcons/TimeComplexityIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/TimeComplexityIconWhite.svg',
      desc: 'Make algorithms run faster',
      pricing: { IN: '₹1499' },
    },
  ],
  InterviewPreparation: [
    {
      id: 'courses/coding-interview-patterns',
      title: 'Coding Interview Patterns',
      img: '/Assets/navIcons/coursesNavIcons/InterviewPatternIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/InterviewPatternIconWhite.svg',
      desc: 'Popular coding interview patterns',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/dsa-problems',
      title: 'Problem Solving with DSA',
      img: '/Assets/navIcons/coursesNavIcons/ProblemSolvingDSAIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemSolvingDSAIconWhite.svg',
      desc: 'Problem-solving made easy with DSA',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/recursion',
      title: 'Recursion',
      img: '/Assets/navIcons/coursesNavIcons/RecursionIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/RecursionIconWhite.svg',
      desc: 'Recursive programming made simple',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/dynamic-programming',
      title: 'Dynamic Programming',
      img: '/Assets/navIcons/coursesNavIcons/DynamicPrgIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DynamicPrgIconWhite.svg',
      desc: 'Dynamic Programming for optimization',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/bitwise-for-coding-interview',
      title: 'Bitwise Operations for Coding Interviews',
      img: '/Assets/navIcons/coursesNavIcons/BitwiseCodingIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/BitwiseCodingIconWhite.svg',
      desc: 'Crack bitwise coding problems',
      pricing: { IN: '₹1499' },
    },
    {
      id: 'courses/binary-search-for-coding-interviews',
      title: 'Binary Search for Coding Interviews',
      img: '/Assets/navIcons/coursesNavIcons/BinarySearchIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/BinarySearchIconWhite.svg',
      desc: 'Fast search with Binary Search',
      pricing: { IN: '₹1499' },
    },
  ],
  FrontEndDevelopment: [
    {
      id: 'courses/html',
      title: 'HTML',
      img: '/Assets/navIcons/coursesNavIcons/HTMLIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/HTMLIconWhite.svg',
      desc: 'Build your own website',
      pricing: { IN: '₹499' },
    },
    {
      id: 'courses/css',
      title: 'CSS',
      img: '/Assets/navIcons/coursesNavIcons/CSSIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CSSIconWhite.svg',
      desc: 'Make your website beautiful with CSS',
      pricing: { IN: '₹499' },
    },
    {
      id: 'courses/bootstrap',
      title: 'Bootstrap',
      img: '/Assets/navIcons/coursesNavIcons/BootstrapIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/BootstrapIconWhite.svg',
      desc: 'Build fast and responsive websites.',
      pricing: { IN: '₹499' },
    },
    {
      id: 'courses/javascript',
      title: 'JavaScript',
      img: '/Assets/navIcons/coursesNavIcons/JsIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/JsIconWhite.svg',
      desc: 'Interactive web applications with JavaScript.',
      pricing: { IN: '₹499' },
    },
  ],
  SoftwareTesting: [
    {
      id: 'courses/python',
      title: 'Python',
      img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PythonIconWhite.svg',
      desc: 'Learn python from scratch',
      pricing: { IN: '₹499' },
    },
    {
      id: 'courses/selenium',
      title: 'Selenium',
      img: '/Assets/navIcons/coursesNavIcons/SeleniumIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/SeleniumIconWhite.svg',
      desc: 'Automated web testing framework',
      earlyAccess: true,
    },
  ],
};
